export class RequestHistoricalData {
  start: Date;
  stop: Date;
  timezone: string;
  companySugarId: string;
  listeningPop: string;
  frompop: string;
  topop: string;
  name: string;
  etreeId: string;
  connectionPointId: any;
  sentAt: Date;
  available: boolean;
  path: string;
  period: string;
  userName: string;
  email: string;
  companyName: string;
  formattedSentAt: string;
  formattedAvailable: string;
}
